import { AnimatePresence, motion } from 'framer-motion';
import { LOCK_COLORS } from 'shared/constants/common';

type AnimatedLockProps = {
	isComplete: boolean | undefined;
	delay?: number;
};

export const AnimatedLock = ({ isComplete, delay }: AnimatedLockProps) => {
	const transition = { duration: 0.2, delay: delay ? delay : 0 };
	const status = isComplete ? 'complete' : 'incomplete';
	const fillColor = LOCK_COLORS[status];

	return (
		<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<motion.path
				opacity="0.5"
				initial={{ fill: LOCK_COLORS.incomplete }}
				animate={{ fill: fillColor }}
				transition={transition}
				d="M1 8C1 6.58579 1 5.87868 1.43934 5.43934C1.87868 5 2.58579 5 4 5H8C9.41421 5 10.1213 5 10.5607 5.43934C11 5.87868 11 6.58579 11 8C11 9.41421 11 10.1213 10.5607 10.5607C10.1213 11 9.41421 11 8 11H4C2.58579 11 1.87868 11 1.43934 10.5607C1 10.1213 1 9.41421 1 8Z"
			/>
			<AnimatePresence exitBeforeEnter>
				<motion.path
					key="unlocked"
					initial={{ opacity: 0 }}
					animate={{ opacity: isComplete ? 1 : 0 }}
					fill={LOCK_COLORS.complete}
					transition={transition}
					d="M3.375 4C3.375 2.55025 4.55025 1.375 6 1.375C7.22263 1.375 8.2509 2.21121 8.54232 3.34347C8.59395 3.54404 8.79839 3.66479 8.99896 3.61316C9.19953 3.56154 9.32027 3.3571 9.26865 3.15653C8.89401 1.70095 7.57313 0.625 6 0.625C4.13604 0.625 2.625 2.13604 2.625 4V5.0273C2.84325 5.011 3.09132 5.00443 3.375 5.00179V4Z"
				/>

				<motion.path
					key="locked"
					initial={{ opacity: 1 }}
					animate={{ opacity: isComplete ? 0 : 1 }}
					fill={LOCK_COLORS.incomplete}
					transition={transition}
					d="M3.375 4C3.375 2.55025 4.55025 1.375 6 1.375C7.44975 1.375 8.625 2.55025 8.625 4V5.00179C8.90868 5.00443 9.15675 5.011 9.375 5.0273V4C9.375 2.13604 7.86396 0.625 6 0.625C4.13604 0.625 2.625 2.13604 2.625 4V5.0273C2.84325 5.011 3.09132 5.00443 3.375 5.00179V4Z"
				/>
			</AnimatePresence>
		</svg>
	);
};
